import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "selected", "typeIcon"]
  static values = {
    type: String
  }

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.hasPreviewTarget && this.previewTarget.textContent.trim() !== "") {
      this.inputTarget.classList.add("d-none")
      this.previewTarget.classList.remove("d-none")
    } else {
      this.inputTarget.classList.remove("d-none")
      this.previewTarget.classList.add("d-none")
    }

    this.toggleHelpIcons();
    this.setAcceptOnFileInput();
  }

  removeFile() {
    if (this.hasPreviewTarget) {
      this.previewTarget.textContent = ""
      this.toggle()
    }

    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
  }

  selectChanged() {
    if (this.hasPreviewTarget) {
      this.previewTarget.textContent = ""
    }

    this.toggle()
  }

  toggleHelpIcons() {
    if (!this.hasTypeIconTarget || !this.hasTypeValue) {
      return;
    }

    for (const icon of this.typeIconTargets) {
      if (icon.dataset.iconType == this.selectedTarget.value) {
        icon.classList.remove("d-none")
      }
      else {
        icon.classList.add("d-none")
      }
    }
  }

  setAcceptOnFileInput() {
    if (!this.hasSelectedTarget || !this.hasTypeValue) {
      return;
    }

    switch(this.selectedTarget.value) {
      case "document":
        this.inputTarget.accept = (this.typeValue == "template" ? ".pdf" : ".txt, .pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx");
        break;
      case "image":
        this.inputTarget.accept = ".jpeg, .jpg, .png";
        break;
      case "video":
        this.inputTarget.accept = ".mp4";
        break;
    }
  }
}
